// extracted by mini-css-extract-plugin
export var container = "_8y-0";
export var error = "_8y-9";
export var label = "_8y-5";
export var light = "_8y-6";
export var md = "_8y-3";
export var sm = "_8y-2";
export var thin = "_8y-8";
export var thinBold = "_8y-7";
export var vertical = "_8y-4";
export var xs = "_8y-1";